import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ButtonModule } from '@components/button/button.module';
import { HeaderComponent } from './header.component';
import { HeaderDesktopModule } from '@components/header-desktop/header-desktop.module';
import { HeaderMobileModule } from '@components/header-mobile/header-mobile.module';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ButtonModule,
    HeaderDesktopModule,
    HeaderMobileModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule {}
